import { Slide } from "@jelly/lesson";
import first from "./components/first";
import second from "./components/second";
import config from "appConfig";

const principle: Slide = {
  layout: {
    type: "table",
    options: {
      cols: 2,
      rows: 3,
      rowSpan: {
        "1:0": 2,
      },
      colSpan: {
        "0:0": 2,
      },
      colsSize: [1, 3],
      rowsSize: [1, 8, 1],
      gap: "20px",
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "Room acoustics measurement and simulation of an existing space\n",
                  styles: {
                    fontSize: "16px",
                    fontWeight: "700",
                  },
                  scrollbars: false,
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data:
                    `For a high quality room acoustic measurement according to the industrial standard ISO 3382, the room impulse response has to be measured for different sound source and receiver positions, depending on size of the room and the desired quality. In this case, for the sake of a better overview, only a selection of two sound source and two receiver positions are presented.` +
                    `<br />` +
                    `<br />` +
                    `The room impulse response is obtained by radiating a measurement signal (in this case a sine sweep from 45 Hz to 20 kHz) via an omnidirectional measurement loudspeaker and capturing this signal at different receiver positions with a measurement microphone. In three audio examples, you can listen to the measurement signal.` +
                    `<br />` +
                    `<br />` +
                    `The room impulse response is obtained by applying signal processing methods (deconvolution) to the captured signals. Based on this impulse response, the Schroeder curve, describing the energy decay of the room, is calculated allowing the determiniation of standardized room acoustic parameters such as the reverberation time or the clarity value.`,
                  styles: {
                    fontSize: "12px",
                    fontWeight: "600",
                  },
                  scrollbars: true,
                },
              },
            },
          },
          {
            variant: "layout",
            data: {
              type: "carousel",
              options: {
                controlsPosition: "bottom",
                components: [first, second],
              },
            },
          },
        ],
        [
          null,
          {
            variant: "layout",
            data: {
              type: "table",
              options: {
                rows: 1,
                cols: 3,
                components: [
                  [
                    {
                      variant: "blockContainer",
                      data: {
                        styles: {
                          justifyContent: "flex-end",
                        },
                        block: {
                          type: "audioButton",
                          options: {
                            text: "Source 1",
                            theme: "default",
                            icon: "cis-volume-high",
                            shape: "round",
                            size: "standard",
                            url: `${config.ASSETS_URL}/03/case-01/principle/file01_measPure.mp3`,
                          },
                        },
                      },
                    },
                    {
                      variant: "blockContainer",
                      data: {
                        block: {
                          type: "audioButton",
                          options: {
                            text: "Receiver 1",
                            theme: "default",
                            icon: "cis-volume-high",
                            shape: "round",
                            size: "standard",
                            url: `${config.ASSETS_URL}/03/case-01/principle/file02_measPos01.mp3`,
                          },
                        },
                      },
                    },
                    {
                      variant: "blockContainer",
                      data: {
                        styles: {
                          justifyContent: "flex-start",
                        },
                        block: {
                          type: "audioButton",
                          options: {
                            text: "Receiver 2",
                            theme: "default",
                            icon: "cis-volume-high",
                            shape: "round",
                            size: "standard",
                            url: `${config.ASSETS_URL}/03/case-01/principle/file03_measPos02.mp3`,
                          },
                        },
                      },
                    },
                  ],
                ],
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
